module.exports = __webpack_public_path__ + "img/haskell.6d254752.svg";